var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMax = function SvgIconMax(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#fff",
    fillOpacity: 0.64,
    opacity: 0.2,
    rx: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.64,
    fillRule: "evenodd",
    d: "M16.287 11.442c-2.355-.124-4.193 1.516-4.598 4.083-.336 2.126.26 4.717.768 4.847.216.056.735-.343 1.113-.7a.216.216 0 0 1 .262-.028c.59.362 1.256.633 1.991.672 2.418.127 4.56-1.772 4.687-4.2.127-2.426-1.806-4.547-4.224-4.674m-3.944 12.325a.225.225 0 0 0-.293.035c-1.022 1.093-3.635 1.86-3.755.368 0-1.17-.262-2.155-.55-3.24C7.392 19.601 7 18.123 7 15.975 7 10.852 11.185 7 16.147 7S25 11.04 25 16.025c0 4.984-4.014 8.925-8.806 8.925-1.7 0-2.524-.24-3.85-1.183",
    clipRule: "evenodd"
  })));
};
export default SvgIconMax;